function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "393CECE9-01C5-411D-816E-FFFF620CE7A5");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with sketchtool.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Hamburger-Menu-CHANGE-LANGUAGE-NEW",
  transform: "translate(-300.000000, -276.000000)",
  fill: "#FFFFFF"
}, React.createElement("g", {
  id: "Group-3",
  transform: "translate(299.000000, 275.000000)"
}, React.createElement("path", {
  d: "M13.5039619,1.26350044 C13.5039619,-0.195101766 14.6913467,-1.37753248 16.1494198,-1.37753248 L16.1494198,-1.37753248 C17.6104659,-1.37753248 18.7948777,-0.202258091 18.7948777,1.26350044 L18.7948777,18.4290227 C18.7948777,19.8876249 17.6074929,21.0700556 16.1494198,21.0700556 L16.1494198,21.0700556 C14.6883737,21.0700556 13.5039619,19.8947812 13.5039619,18.4290227 L13.5039619,1.26350044 Z",
  id: "Rectangle-1-Copy",
  transform: "translate(16.149420, 9.846262) scale(-1, 1) rotate(-585.000000) translate(-16.149420, -9.846262) "
}), React.createElement("path", {
  d: "M4.46597532,8.85170634 C4.46597532,7.38940629 5.65336011,6.20397787 7.11143325,6.20397787 L7.11143325,6.20397787 C8.57247932,6.20397787 9.75689118,7.38407856 9.75689118,8.85170634 L9.75689118,17.1215456 C9.75689118,18.5838457 8.56950639,19.7692741 7.11143325,19.7692741 L7.11143325,19.7692741 C5.65038718,19.7692741 4.46597532,18.5891734 4.46597532,17.1215456 L4.46597532,8.85170634 Z",
  id: "Rectangle-1-Copy-2",
  transform: "translate(7.111433, 12.986626) scale(-1, -1) rotate(315.000000) translate(-7.111433, -12.986626) "
}))));

var SvgCheckWhite = function SvgCheckWhite(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "24px",
    height: "18px",
    viewBox: "0 0 24 18",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCheckWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/check_white.df2e062e.svg";
export { ForwardRef as ReactComponent };